<template>
  <div>
    <Head title="Notificações" />
    <div class="shadow_box rounded-lg p-6">
      <div class="mb-6 flex flex-nowrap items-center">
        <h1 class="mr-3 text-2xl text-gray-777 font-roboto uppercase">Notificações</h1>
      </div>
      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="scheduled-notifications/list"
        no-data-label="Nenhuma notificação cadastrada"
        no-result-label="Nenhuma notificação encontrada"
      >
        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4" v-if="row.allow_update">
            <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
            <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4" v-if="row.allow_update">

            <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
            <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
          </div>
        </template>

        <template #after.reload-button>
          <div class="flex flex-col lg:flex-row w-full">
            <button class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full mt-4 ml-0 lg:ml-2 lg:mt-0" @click.prevent="openModalEdit({})">
              <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-2" /><span class=""> Criar Notificação</span>
            </button>
          </div>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
    <modal-edit
      ref="modalEdit"
      title="Notificação"
      url="scheduled-notifications"
      @submitForm="reloadTable"
    >
      <template #form="{item}">
        <text-input v-model="item.title" :error="item.errors.title" class="w-full" label="Título" />
        <div class="items-center mt-6 w-full lg:w-2/3 ">
          <div class="w-full">Enviar para:</div>
          <div class="flex items-center mt-6 w-full lg:w-1/1 ">
          <label class="select-none" for="unlimited">
            <input id="patients" v-model="item.checkPatient" class="mr-1" type="checkbox" />
            <span class="text-sm">Pacientes</span>
          </label>&nbsp;&nbsp;&nbsp;&nbsp;
          <label class="select-none" for="unlimited">
            <input id="professional" v-model="item.checkProfessional" class="mr-1" type="checkbox" />
            <span class="text-sm">Profissionais de Saúde</span>
          </label>
        </div>
        </div>



        <date-time-input v-model="item.date" :error="item.errors.date" class="mt-6 w-full lg:w-1/3" label="Data de envio" />


        <!-- <div class="w-full mt-6 ">
          <div class="w-full">Tipo de notificação</div>
          <div class="flex items-center mt-6 w-full lg:w-1/1 ">
          <label class="select-none" for="unlimited">
            <input id="email" v-model="item.checkEmail" class="mr-1" type="checkbox"  />
            <span class="text-sm">E-mail</span>
          </label>&nbsp;&nbsp;&nbsp;&nbsp;
          <label class="select-none" for="unlimited">
            <input id="notiApp" v-model="item.checkNotiApp" class="mr-1" type="checkbox"  />
            <span class="text-sm">Notificação do App</span>
          </label>
        </div>
        </div> -->
        
        <textarea-input v-model="item.body" :error="item.errors.body" class="mt-6 w-full" label="Notificação" />
      </template>
    </modal-edit>
  </div>
</template>

<script>
import { Head, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout/Layout'
import LoadingButton from '@/Shared/Components/LoadingButton'
import ModalDelete from '@/Shared/Modal/ModalDelete'
import ModalEdit from '@/Shared/Modal/ModalEdit'
import SwitchInput from '@/Shared/Fields/SwitchInput'
import TextInput from '@/Shared/Fields/TextInput'
import DataTable from '@/Shared/Components/DataTable'
import SelectInput from '@/Shared/Fields/SelectInput'
import CheckboxInput from '@/Shared/Fields/CheckboxInput'
import DateTimeInput from '@/Shared/Fields/DateTimeInput'
import TextareaInput from '@/Shared/Fields/TextareaInput'
import draggable from 'vuedraggable'

export default {
  props: {
    to_options: Object,
    types_options: Object,
  },
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    SwitchInput,
    TextInput,
    DataTable,
    SelectInput,
    CheckboxInput,
    DateTimeInput,
    TextareaInput,
    draggable,
  },
  layout: Layout,
  data() {
    return {
      item: null,
      loadModalConfig: false,
      vitalDataOrdered: null,
      loadTable: true,
      columns: [
        {
          uniqid: 'notification_title',
          field: 'title',
          label: 'Título',
          visible: true,
          sortable: true,
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? val : ''
        },
        {
          uniqid: 'notification_body',
          field: 'body',
          label: 'Notificação',
          visible: true,
          sortable: true,
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? val : ''
        },
        {
          uniqid: 'notification_to',
          field: 'to',
          label: 'Enviar para',
          visible: true,
          sortable: true,
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? row.to_label : ''
        },
        {
          uniqid: 'notification_type',
          field: 'type',
          label: 'Tipo de notificação',
          visible: true,
          sortable: true,
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? row.type_label : ''
        },
        {
          uniqid: 'notification_date',
          field: 'date',
          label: 'Data de envio',
          visible: true,
          sortable: true,
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? this.$filters.formatDateTime(val) : ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
          format: (val, row) => ''
        },
      ],
    }
  },
  mounted() {

  },
  methods: {
    filter_types_options(item) {
      let types = {};
      for(let type in this.types_options) {
        if(item.to.includes('patient') || ['email', 'app'].includes(type)) {
          let label = this.types_options[type];
          types[type] = label;
        } else if(item.type.includes(type)) {
          item.type = item.type.filter(t => t !== type);
        }
      }
      return types;
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/scheduled-notifications/${item.id}`, `Deseja realmente excluir a notificação?`);
    },
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        title: item.title,
        body: item.body,
        type: item.type ?? [],
        to: item.to ?? [],
        // date: item.date,
        date: this.formatDateForInput(item.date),
        checkProfessional: item.checkProfessional ?? false,
        checkPatient: item.checkPatient ?? false,
        checkEmail: item.checkEmail ?? false,
        checkNotiApp: item.checkNotiApp ?? false,
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    formatDateForInput(date) {
      if (!date) return '';
      const d = new Date(date);
      const pad = n => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }
  },
}
</script>
